import Axios from "@/plugins/Axios";

export class JustificativaFaltaService {
  async syncAll(pageNumber, { query = "", status = "", aba = "todas" } = {}) {
    const response = await Axios().get("justificativas-falta", {
      params: { page: pageNumber, query, status, aba },
    });
    return response.data;
  }

  async portalAluno(pageNumber, query = "", matricula_id = "") {
    const response = await Axios().get("justificativas-falta", {
      params: { page: pageNumber, query, matricula_id },
    });
    return response.data;
  }

  async tipos() {
    const response = await Axios().get("justificativas-falta/tipos");
    return response.data.tipos;
  }

  async matriculasParaSelecao() {
    const response = await Axios().get("justificativas-falta/matriculas-selecao");
    return response.data;
  }

  async find(id) {
    const response = await Axios().get(`justificativas-falta/${id}`);
    return response.data;
  }

  async store(formData) {
    const response = await Axios().post("justificativas-falta", formData);
    return response.data;
  }

  async update(id, formData) {
    formData.append("_method", "PUT");
    const response = await Axios().post(`justificativas-falta/${id}`, formData);
    return response.data;
  }

  async destroy(id) {
    const response = await Axios().delete(`justificativas-falta/${id}`);
    return response.data;
  }

  async aprovar(id, data_inicial, data_final) {
    const response = await Axios().post(`justificativas-falta/${id}/aprovar`, {
      data_inicial,
      data_final,
    });
    return response.data;
  }

  async rejeitar(id, motivo_rejeicao) {
    const response = await Axios().post(`justificativas-falta/${id}/rejeitar`, {
      motivo_rejeicao,
    });
    return response.data;
  }

  async revogar(id, motivo_revogacao) {
    const response = await Axios().post(`justificativas-falta/${id}/revogar`, {
      motivo_revogacao,
    });
    return response.data;
  }

  async baixarAtestado(id) {
    const response = await Axios().get(`justificativas-falta/${id}/anexo`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `atestado_justificativa_${id}.pdf`;
    link.click();
  }
}
export default new JustificativaFaltaService();
